import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M526.298905 0L434 92.1683552 1301.63582 959.934725 434 1827.57054 526.298905 1920 1486.23363 959.934725z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "matrix(-1 0 0 1 1920.305 0)"
});

var IconArrowOpenStartLine = /*#__PURE__*/function (_Component) {
  _inherits(IconArrowOpenStartLine, _Component);

  var _super = _createSuper(IconArrowOpenStartLine);

  function IconArrowOpenStartLine() {
    _classCallCheck(this, IconArrowOpenStartLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconArrowOpenStartLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconArrowOpenStart",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconArrowOpenStartLine.displayName = "IconArrowOpenStartLine";
  return IconArrowOpenStartLine;
}(Component);

IconArrowOpenStartLine.glyphName = 'arrow-open-start';
IconArrowOpenStartLine.variant = 'Line';
IconArrowOpenStartLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconArrowOpenStartLine;
export { IconArrowOpenStartLine };